import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from "@nuxtjs/composition-api";

import { useRetailerProductPrices } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'RetailerProductPrice',
  props: {
  retailerProductId: {
    type: String,
    required: true,
  },
  selectedProductVariantId: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;



const { retailerProductId, selectedProductVariantId } = toRefs(props);
const { isPriceRange, price, salePrice, savePercentage, variantPrice, variantSalePrice, variantSavePercentage } =
  useRetailerProductPrices(retailerProductId, selectedProductVariantId);

return { __sfc: true,props, retailerProductId, selectedProductVariantId, isPriceRange, price, salePrice, savePercentage, variantPrice, variantSalePrice, variantSavePercentage }
}

})